import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  ListItemText,
  Grid,
  Menu,
  ListItemIcon,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { useFormik } from "formik";
import { useAuth } from "../../../../AuthProvider";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const TeachersClassSchedule = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  // const [filteredData1, setFilteredData1] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const { oId,role,pId,userId } = useAuth();
  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };
  const handleClose = () => {
    setExportAnchorEl(null);
  };

    const [users, setUsers] = useState([]);
        const [selectedUsers, setSelectedUsers] = useState('');
        const isPrincipal = role?.startsWith("PRINCIPAL") || false;
        const UserId = userId || selectedUsers;
      
        useEffect(() => {
          const fetchUsers = async () => {
              try {
                  const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/SCHEDULE_MEETING/${oId}/${pId}`);
                  if (!response.ok) {
                      throw new Error('Failed to fetch users');
                  }
                  const data = await response.json();
                  setUsers(data);
                  if (data.length > 0) {
                    setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
                }
              } catch (error) {
                  console.error('Error fetching users:', error);
              }
          };
          fetchUsers();
      }, []);


  useEffect(() => {
    const fetchData = async () => {
      if(!UserId) return;
      setLoading(true);
      try {
        const response = await fetch(
          `${baseUrl}/api/teacherTimeTable/getAllTeacherDetails/${oId}/${pId}/${UserId}`
        );
        const data = await response.json();

        if (Array.isArray(data)) {
          setFilteredData(data); // Set only if data is an array
        } else {
          console.error("Expected an array but got:", data);
          setFilteredData([]); // Fallback to an empty array
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
        setFilteredData([]); // Prevent map error
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [UserId]);

  const filteredResults = filteredData.filter((row) => {
    if (!searchQuery) return true; // Show all if no search input

    const teacherfirstName = row.teacherFirstName?.toLowerCase() || "";
    const teacherLastName = row.teacherLastName?.toLowerCase() || "";
    const teacherId = row.teacherId?.toLowerCase() || "";
    const fullName = `${teacherfirstName} ${teacherLastName}`;
    const query = searchQuery.toLowerCase();

    return fullName.includes(query) || teacherId.includes(query);
  });

const exportToExcel = () => {
  const processedData = filteredData.map(
    (
      {
        teacherId,
        teacherFirstName,
        teacherLastName,
        teacherContactNumber,
        teacherEmailId,
        subject,
      },
      index
    ) => ({
      Sno: index + 1,
      TeacherID: teacherId,
      TeacherName: `${teacherFirstName} ${teacherLastName}`,
      ContactNumber: teacherContactNumber,
      Email: teacherEmailId?.trim() ? teacherEmailId : "N/A",
      Subjects: subject?.length ? subject.join(", ") : "N/A",
    })
  );

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Teachers_List");

  // Add headers
  worksheet.columns = [
    { header: "S.No", key: "Sno", width: 10 },
    { header: "Teacher ID", key: "TeacherID", width: 15 },
    { header: "Teacher Name", key: "TeacherName", width: 25 },
    { header: "Contact Number", key: "ContactNumber", width: 20 },
    { header: "Email", key: "Email", width: 30 },
    { header: "Subjects", key: "Subjects", width: 40 },
  ];

  // Add data to worksheet
  processedData.forEach((data) => {
    worksheet.addRow(data);
  });

  // Style headers
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "87CEEB" }, // Light Blue Header
    };
  });

  // Write and download file
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Teacher_List.xlsx";
    link.click();
  });

  handleExportClose();
};

  const exportToPDF = () => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("Teachers List", 10, 8);

    // Table
    doc.autoTable({
      startY: 20,
      head: [
        [
          "S.No",
          "Teacher ID",
          "Teacher Name",
          "Contact Number",
          "Email",
          "Subjects",
        ],
      ],
      body: filteredData.map((row, index) => [
        index + 1,
        row.teacherId,
        `${row.teacherFirstName} ${row.teacherLastName}`,
        row.teacherContactNumber,
        row.teacherEmailId || "N/A",
        row.subject.join(", "),
      ]),
      styles: {
        lineWidth: 0.2,
        lineColor: "#B6B9CD",
      },
      headStyles: {
        fillColor: [63, 81, 181], // Dark Blue Header
        textColor: [255, 255, 255],
        halign: "center",
      },
      bodyStyles: {
        halign: "center",
      },
      theme: "grid",
    });

    doc.save("Teacher_List.pdf");
    handleExportClose();
  };

  const exportToJSON = () => {
    const processedData = filteredData.map(
      ({
        teacherId,
        teacherFirstName,
        teacherLastName,
        teacherContactNumber,
        teacherEmailId,
        subject,
      }) => ({
        TeacherID: teacherId,
        TeacherName: `${teacherFirstName} ${teacherLastName}`,
        ContactNumber: teacherContactNumber,
        Email: teacherEmailId,
        Subjects: subject.join(", "),
      })
    );

    const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(processedData, null, 2)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    link.download = "Teacher_List.json";
    link.click();
    handleExportClose();
  };

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop: "60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              mb: 2,
              textAlign: "center",
              fontSize: "23px",
            }}
          >
            Teachers Schedule
          </Typography>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
          flexWrap="wrap"
        >
          {/* Left Section: Search + User Dropdown */}
          <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
            <TextField
              label="Search by Teacher Name"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />

            {/* {isPrincipal && (
              <FormControl style={{ width: "200px" }} size="small">
                <InputLabel>Select Schedule Admin</InputLabel>
                <Select
                  value={selectedUsers}
                  onChange={(e) => setSelectedUsers(e.target.value)}
                  label="Select Schedule Admin"
                >
                  {users.map((user) => (
                    <MenuItem key={user.userId} value={user.userId}>
                      {user.userId} - {user.firstName} {user.lastName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )} */}
          </Box>

          {/* Right Section: Export + Schedule */}
          <Box display="flex" gap={2} alignItems="center" mt={{ xs: 2, sm: 0 }}>
            <Button
              variant="contained"
              onClick={handleExportClick}
              sx={{
                backgroundColor: "#6E69B0",
                color: "white",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#58548E",
                },
              }}
              startIcon={<PresentToAllIcon />}
            >
              Export
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#6E69B0",
                color: "white",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#58548E",
                },
              }}
              onClick={() => navigate("/AddNewClassSchedules")}
            >
              Schedule New Class
            </Button>
          </Box>

          {/* Export Menu */}
          <Menu
            anchorEl={exportAnchorEl}
            open={isExportMenuOpen}
            onClose={handleExportClose}
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
              },
            }}
          >
            <MenuItem
              onClick={exportToExcel}
              sx={{
                color: "#3f51b5",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#e8f0fe",
                },
              }}
            >
              <ListItemIcon sx={{ color: "#00796b" }}>
                <SimCardDownloadIcon />
              </ListItemIcon>
              <ListItemText
                primary="Excel"
                sx={{ fontWeight: "bold", color: "#00796b" }}
              />
            </MenuItem>

            <MenuItem
              onClick={exportToPDF}
              sx={{
                color: "#d32f2f",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#fdecea",
                },
              }}
            >
              <ListItemIcon sx={{ color: "#d32f2f" }}>
                <PictureAsPdfIcon />
              </ListItemIcon>
              <ListItemText
                primary="PDF"
                sx={{ fontWeight: "bold", color: "#d32f2f" }}
              />
            </MenuItem>

            <MenuItem
              onClick={exportToJSON}
              sx={{
                color: "#388e3c",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#e8f5e9",
                },
              }}
            >
              <ListItemIcon sx={{ color: "#6a1b9a" }}>
                <FilePresentIcon />
              </ListItemIcon>
              <ListItemText
                primary="JSON"
                sx={{ fontWeight: "bold", color: "#6a1b9a" }}
              />
            </MenuItem>
          </Menu>
        </Box>



          <GlobalStyles
            styles={{
              ".custom-sidebar-scrollbar": {
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "grey #e0e0e0",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                width: "6px", // For WebKit-based browsers
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                background: "#f1f1f1", // Track color
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                backgroundColor: "grey", // Thumb color
                borderRadius: "10px",
              },
              ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
            }}
          />

          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "800px",
              overflow: "auto",
            }}
            className="custom-sidebar-scrollbar"
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "6px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    S.No
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "2px solid #ddd",
                      padding: "6px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Tech Id
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "2px solid #ddd",
                      padding: "6px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      fontSize: "14px",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "bold",
                    }}
                  >
                    Teacher Name
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "6px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      backgroundColor: "#fff9c4",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Subject
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "6px",
                      textAlign: "center",
                      backgroundColor: "#fff9c4",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Mobile No
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "6px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Email
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "6px",
                      backgroundColor: "#fff9c4",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              {loading ? (
                <TableBody>
                  <TableRow>
                    {/* <TableCell colSpan={13} sx={{ textAlign: "center" }}>
                      <CircularProgress size={20} />
                    </TableCell> */}

                    <TableCell
                      colSpan={13}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <CircularProgress />
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          Loading Data...
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : filteredResults.length === 0 ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={13} sx={{ textAlign: "center" }}>
                      No data found
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  {filteredResults.map((row, index) => (
                    <TableRow
                      key={row.id}
                      style={{
                        backgroundColor: "white",
                        transition: "background-color 0.3s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "white"; // Default color
                      }}
                    >
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "3px",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {row.teacherId}
                      </TableCell>
                      {/* <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {row.teacherFirstName} {row.teacherLastName}
                      </TableCell> */}
                       <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "2px",
    textAlign: "center",
    maxWidth: "80px",
    minWidth: "80px",
  }}
>
  <Box
    sx={{
      whiteSpace: "normal",       // Allow wrapping
      wordBreak: "break-word",    // Break long words
      overflowWrap: "break-word",
      fontSize: "13px",
    }}
  >
    {row.teacherFirstName} {row.teacherLastName}
  </Box>
</TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {Array.isArray(row.subject)
                          ? row.subject.join(", ")
                          : row.subject}
                      </TableCell>

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {row.teacherContactNumber}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                          fontSize: "14px",
                        }}
                      >
                        {row.teacherEmailId || "N/A"}
                      </TableCell>

                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "6px", // Slightly more padding for better spacing
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                          // Light background to differentiate
                          "&:hover": {
                            backgroundColor: "#f1f1f1", // Slight hover effect on the cell
                          },
                        }}
                      >
                        <Button
                          type="button"
                          onClick={() =>
                            navigate(`/TeacherTimeTable`, {
                              state: { student: row },
                            })
                          }
                          sx={{
                            backgroundColor: "#1976d2",
                            color: "white",
                            fontSize: "0.65rem", // Slightly increased font size for better readability
                            padding: "4px 12px", // Adjusted padding for better button size
                            height: "28px", // Slightly increased height for comfort
                            borderRadius: "20px", // Rounded button
                            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)", // Adds subtle shadow
                            textTransform: "uppercase", // Capitalizes button text for emphasis
                            transition: "all 0.3s ease", // Smooth transition for hover effects
                            "&:hover": {
                              backgroundColor: "#1565c0", // Darker shade on hover
                              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)", // More shadow on hover
                            },
                          }}
                        >
                         View Time Table
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};

export default TeachersClassSchedule;